"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIE = exports.addDelimiter = void 0;
//determines if browser is IE
const isIE = () => {
  return navigator.userAgent.indexOf("MSIE") !== -1 || !!document.documentMode === true;
};

//Custom function for adding an aditional delimiter to text for every specified number of characters
//use cases: credit card, expiration date fields (see examples)
exports.isIE = isIE;
const addDelimiter = function (value, lastValue, delimiter) {
  let maxLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  //logic for handling custom delimter after a specified number of characters
  const adjust = Math.floor(value.length / delimiter.spacing);
  const numDelimiters = Math.floor((value.length - adjust) / delimiter.spacing);

  //if the length of the value, taking into account the existing delimiters, modulo the spacing between each delimter is zero, then insert another delimiter
  if ((value.length - numDelimiters) % delimiter.spacing === 0) {
    //direction matters - determine if user is inserting or deleting
    if (value.length > lastValue.length) {
      if (maxLength && value.length + 1 < maxLength || !maxLength) {
        if ((value.length - adjust) % delimiter.spacing === 0) {
          const lastChar = value[value.length - 1];
          value = value.substring(0, value.length - 1);
          value += delimiter.char;
          value += lastChar;
        } else {
          value += delimiter.char;
        }
      }
    } else {
      value = value.substring(0, value.length - 1);
    }
  }
  return value;
};
exports.addDelimiter = addDelimiter;